// extracted by mini-css-extract-plugin
export default {"title":"title_title__r59Pr","red-line":"title_red-line__jsQU2"};